module.exports = __webpack_public_path__ + "media/musicbox.73f65870.ogg";